// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"cd5dba40","79":"f29c68d3","439":"82ffd58a","520":"a6aab798","667":"a4139659","977":"dbd2a82e"}[chunkId] + ".chunk.js";
};